import React, { useState, Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { getLoginUser } from "../../redux/actions/loginAuth/LoginAuth";

import "../../style/login.css";
import "../../style/loginicon.css";
import { Redirect, useHistory, useLocation } from "react-router-dom";
import { Alert, Spinner } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

const eye = <FontAwesomeIcon icon={faEye} />;

const Login = (props) => {
  const { getLoginUser } = props;
  const { login, loginUser, loginInput } = props.loginUser;

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [redirect, setRedirect] = useState(null);
  const [isRevealPwd, setIsRevealPwd] = useState(false);
  const [isusername, setisusername] = useState(false);
  const [ispassword, setispassword] = useState(false);
  const [isuserandpass, setisuserandpass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [authError, setAuthError] = useState(false);

  const history = useHistory();
  const location = useLocation();

  // 🔹 Clear errors when coming back from Forgot Password
  useEffect(() => {
    if (location.state?.fromForgotPassword) {
      setAuthError(false);
      setisusername(false);
      setispassword(false);
      setisuserandpass(false);

      // Reset location state so this effect doesn't trigger again
      history.replace("/em", {});
    }
  }, [location.state, history]);

  const togglePasswordVisiblity = () => {
    setIsRevealPwd((s) => !s);
  };

  const handleUserNameChange = (e) => {
    setUserName(e.target.value);
    if (authError) setAuthError(false);
    if (isusername || isuserandpass) {
      setisusername(false);
      setisuserandpass(false);
    }
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (authError) setAuthError(false);
    if (ispassword || isuserandpass) {
      setispassword(false);
      setisuserandpass(false);
    }
  };

  // React to login results
  useEffect(() => {
    if (!loading) {
      // Skip showing old Redux errors if coming from Forgot Password
      if (location.state?.fromForgotPassword) return;

      if (loginUser) {
        setAuthError(false);
        if (loginUser.RoleName === "Admin") {
          setRedirect(<Redirect to="/adminDashboard" />);
        } else {
          setRedirect(<Redirect to="/employeeDashboard" />);
        }
      } else if (loginInput === false) {
        setAuthError(true);
      }
    }
  }, [loginUser, loginInput, loading, location.state]);

  const handleClickSign = async (e) => {
    e.preventDefault();

    setAuthError(false);

    // basic validations
    if (!userName && !password) {
      setisuserandpass(true);
      setisusername(false);
      setispassword(false);
      return;
    } else if (!userName) {
      setisusername(true);
      setisuserandpass(false);
      setispassword(false);
      return;
    } else if (!password) {
      setispassword(true);
      setisusername(false);
      setisuserandpass(false);
      return;
    }

    setLoading(true);
    setisusername(false);
    setisuserandpass(false);
    setispassword(false);
localStorage.setItem("loginTime", Date.now().toString()); // ✅ saves login time

    try {
      await getLoginUser(userName, password);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Fragment>
      {login && redirect}
      <div className="login">
        <div className="login-left-image"></div>
        <div className="login-div">
          <form>
            <div>
              {authError && <Alert color="danger">Incorrect UserName or Password</Alert>}
              {isusername && <Alert color="danger">Please Enter The UserName</Alert>}
              {ispassword && <Alert color="danger">Please Enter The Password</Alert>}
              {isuserandpass && <Alert color="danger">Please Enter The UserName and Password</Alert>}

              <h2>Login</h2>
              <label>Username</label>
              <input
                type="text"
                name="name"
                placeholder="Enter UserName"
                value={userName}
                onChange={handleUserNameChange}
                disabled={loading}
                autoComplete="username"
              />

              <label>Password</label>
              <input
                type={isRevealPwd ? "text" : "password"}
                value={password}
                name="password"
                placeholder="Enter Password"
                onChange={handlePasswordChange}
                disabled={loading}
                autoComplete="current-password"
              />
              <i className="iclass" onClick={togglePasswordVisiblity}>{eye}</i>

              <div className="bg-info">
                <span
                  className="float-right"
                  style={{ cursor: "pointer", color: "#0c3747" }}
                  onClick={() => history.push("/forgot-password")}
                >
                  Forgot Password
                </span>
              </div>
            </div>

            <button className="btn-login" onClick={handleClickSign} disabled={loading}>
              {loading ? (
                <>
                  <Spinner size="sm" color="light" /> Signing in...
                </>
              ) : "SIGN IN"}
            </button>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  loginUser: state.loginAuthReducer,
});

export default connect(mapStateToProps, { getLoginUser })(Login);